import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { CopyOutlined } from '@ant-design/icons';
import { styleVariables } from '../../style';
import styled from '@xstyled/styled-components';
import { message, Tooltip } from 'antd';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledCopyIcon = styled(CopyOutlined)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  font-size: ", "px;\n  color: ", ";\n  &:hover {\n    color: ", ";\n  }\n"])), function (_ref) {
  var fontSize = _ref.fontSize;
  return fontSize || 32;
}, styleVariables.colors.light.primary, styleVariables.colors.blue3);
export var CopyIcon = function CopyIcon(_ref2) {
  var value = _ref2.value,
      tooltipTitle = _ref2.tooltipTitle,
      successMessage = _ref2.successMessage,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 32 : _ref2$size;
  var handleCopy = useCallback(function (e) {
    e.stopPropagation();
    if (!value) return;
    navigator.clipboard.writeText(value);

    if (successMessage) {
      message.success(successMessage);
    }
  }, [value, successMessage]);
  if (!value) return null;

  var icon = /*#__PURE__*/_jsx(StyledCopyIcon, {
    fontSize: size,
    onClick: handleCopy
  });

  if (tooltipTitle) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: tooltipTitle,
      children: icon
    });
  }

  return icon;
};